
// export const isAuthorizedRoute = (allowedRoute: any, path: string): boolean => {
//   return true
// };
const routeAliasMap: Record<string, string> = {
  "/society/addsocietymaster": "/society/societymaster",
  "/society/editsocietymaster/:identifier": "/society/societymaster",
  "/society/societyview/:identifier": "/society/societymaster",

  "/property/addpropertymaster": "/masters/propertymaster",
  "/property/editpropertymaster/:identifier": "/masters/propertymaster",
  "/property/propertyview/:identifier": "/masters/propertymaster",

  "/members/addmembers": "/masters/membersmaster",
  "/member/editmembermaster/:identifier": "/masters/membersmaster",
  "/members/membersProfile/:identifier": "/masters/membersmaster",

  "/vendor/addvendormaster": "/vendor/vendormaster",
  "/vendor/editvendor/:identifier": "/vendor/vendormaster",
  "/vendor/vendorview/:identifier": "/vendor/vendormaster",

  "/tenant/updateTenant/:identifier": "/tenant/tenant",
  "/tenant/tenantview/:identifier": "/tenant/tenant",
  "/tenant/addtenant": "/tenant/tenant",

  "/parententity/addparententity": "/parententity",
  "/parententity/editparententity/:identifier": "/parententity",
  "/eventbooking/eventbooking": "/applications/applications",
  "/eventbooking/eventbooking/:identifier": "/applications/applications",

  "/bankstatement/bankstatement": "/payment/payment",
};




function normalizePath(path: string): string {
  for (const alias in routeAliasMap) {
    const regexPattern = alias.replace(/:[^/]+/g, '[^/]+');
    const regex = new RegExp(`^${regexPattern}$`, 'i'); 
    if (regex.test(path)) {
      return routeAliasMap[alias];
    }
  }
  return path.toLowerCase();
}

export const isAuthorizedRoute = (allowedRoutes: string[], path: string): boolean => {
  const normalizedPath = normalizePath(path?.toLowerCase());
  return allowedRoutes.some(route => route?.toLowerCase() === normalizedPath);
};



